import {FrontConfigGlobals} from './bundlerConfigTypes';
import {isWebpackDefinePluginAvailable} from './bundlerHelpers';
import {FrontMobileConfig} from './metroBundlerDefineConfig';

// The `FRONT_CONFIG` variable is replaced at build time by the right object by webpack.DefinePlugin (see `src/webpack/buildWebpackFrontConfig.js`)
declare const FRONT_CONFIG: FrontConfigGlobals;

export const FrontConfig = isWebpackDefinePluginAvailable() ? FRONT_CONFIG : FrontMobileConfig;
